const TARIFF_BUNDLE_YEARLY = {
  title: "AMZScout AI Bundle",
  period: "Period Yearly",
  offer: {
    icon: "MOST POPULAR",
    name: "YEARLY",
    price: 399,
    cents: 99,
    discount: 719.88,
  },
  subTitle: {
    name: "+ 2 AWESOME BONUSES",
    complexTooltip: true,
    bonusOne: "One-on-One Mentor Call",
    bonusTwo: "Booming Product Idea",
  },
  tariff: {
    base: {
      pay: {
        price: 399,
        cents: 99,
        period: "Period Yearly",
      },
      cheap: 320,
      buyNowPath: "/checkout/?bundle=bundle-ai-yearly",
    },
    PL: {
      pay: {
        price: 499,
        cents: 98,
        period: "Period Yearly",
      },
      cheap: 460,
      buyNowPath: "/checkout/?bundle=bundle-ai-pl-yearly",
    },
    R: {
      pay: {
        price: 499,
        cents: 98,
        period: "Period Yearly",
      },
      cheap: 460,
      buyNowPath: "/checkout/?bundle=bundle-ai-oa-yearly",
    },
    PL_R: {
      pay: {
        price: 599,
        cents: 97,
        period: "Period Yearly",
      },
      cheap: 600,
      buyNowPath: "/checkout/?bundle=bundle-ai-pl-oa-yearly",
    },
  },
};

export default TARIFF_BUNDLE_YEARLY;
